import React from "react";
import { useState } from "react";
import { Divider } from "./utils/Divider";
import { LocationControls } from "./LocationControls";
import { ModeControls } from "./ModeControls";
import { MapTypeControls } from "./MapTypeControls";
import { RecordingControl } from "./RecordingControl";
import { DrivingControls } from "./DrivingControls";
import { CreationControls } from "./CreationControls";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useMapState } from "../hooks/useMapState";

export const ControlsContainer = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { 
    mode, 
    setMode, 
    showRoutePlanner, 
    setShowRoutePlanner 
  } = useMapState();

  return (
    <div className="absolute top-4 left-4 z-10 flex">
      {/* Main Controls Panel */}
      <div className={`bg-[#2A2B2E]/90 backdrop-blur-sm rounded-lg shadow-lg transition-all duration-300 ${collapsed ? 'w-0 overflow-hidden opacity-0' : 'w-[200px] opacity-100'}`}>
        <div className="flex flex-col">
          {/* Mode Section */}
          <div className="p-2 border-b border-gray-700">
            <h3 className="text-xs text-gray-400 mb-2">Mode</h3>
            <ModeControls 
              mode={mode} 
              onModeChange={setMode} 
              surveyActive={true} 
              showRoutePlanner={showRoutePlanner}
              onToggleRoutePlanner={() => setShowRoutePlanner(!showRoutePlanner)}
            />
          </div>
          
          {/* Location Section */}
          <div className="p-2 border-b border-gray-700">
            <h3 className="text-xs text-gray-400 mb-2">Location</h3>
            <LocationControls />
          </div>
          
          {/* Map Style Section */}
          <div className="p-2 border-b border-gray-700">
            <h3 className="text-xs text-gray-400 mb-2">Map Style</h3>
            <MapTypeControls />
          </div>
          
          {/* Recording Section */}
          <div className="p-2 border-b border-gray-700">
            <h3 className="text-xs text-gray-400 mb-2">Recording</h3>
            <RecordingControl />
          </div>
          
          {/* Driving Section */}
          <div className="p-2 border-b border-gray-700">
            <h3 className="text-xs text-gray-400 mb-2">Driving</h3>
            <DrivingControls />
          </div>
          
          {/* Creation Section */}
          <div className="p-2">
            <h3 className="text-xs text-gray-400 mb-2">Creating</h3>
            <CreationControls />
          </div>
        </div>
      </div>
      
      {/* Middle Toggle Button */}
      <div className="absolute left-[200px] top-1/2 -translate-y-1/2 z-20">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="bg-[#2A2B2E]/90 backdrop-blur-sm p-1 rounded-r-lg shadow-lg text-white hover:bg-[#3D3F42]/90 transition-colors"
        >
          {collapsed ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />}
        </button>
      </div>
    </div>
  );
};